var styles = {"mBreakpointMd":"(min-width: 960px)","wrapper":"styles_wrapper__2fDDD col-12","detail-rows":"styles_detail-rows__1sPmW","detailRows":"styles_detail-rows__1sPmW","item":"styles_item__2Kx1x","actions":"styles_actions__KEDF9 col-12","buttons":"styles_buttons__1fWwx flex col-12 md-col-6 mx-auto","back":"styles_back__2rLK8"};

export default styles;
//# sourceMappingURL=styles.css.js.map
